export enum AllCountries {
  AF = 'Afghanistan',
  AX = 'AlandIslands',
  AL = 'Albania',
  DZ = 'Algeria',
  AS = 'American Samoa',
  AD = 'Andorra',
  AO = 'Angola',
  AI = 'Anguilla',
  AQ = 'Antarctica',
  AG = 'Antigua and Barbuda',
  AR = 'Argentina',
  AM = 'Armenia',
  AW = 'Aruba',
  AU = 'Australia',
  AT = 'Austria',
  AZ = 'Azerbaijan',
  BS = 'Bahamas',
  BH = 'Bahrain',
  BD = 'Bangladesh',
  BB = 'Barbados',
  BY = 'Belarus',
  BE = 'Belgium',
  BZ = 'Belize',
  BJ = 'Benin',
  BM = 'Bermuda',
  BT = 'Bhutan',
  BO = 'Bolivia',
  BA = 'Bosnia and Herzegovina',
  BW = 'Botswana',
  BV = 'Bouvet Island',
  BR = 'Brazil',
  IO = 'British Indian Ocean Territory',
  BN = 'Brunei Darussalam',
  BG = 'Bulgaria',
  BF = 'Burkina Faso',
  BI = 'Burundi',
  KH = 'Cambodia',
  CM = 'Cameroon',
  CA = 'Canada',
  CV = 'Cape Verde',
  KY = 'Cayman Islands',
  CF = 'Central African Republic',
  TD = 'Chad',
  CL = 'Chile',
  CN = 'China',
  CX = 'Christmas Island',
  CC = 'Cocos Keeling Islands',
  CO = 'Colombia',
  KM = 'Comoros',
  CG = 'Congo',
  CD = 'Congo Democratic Republic',
  CK = 'Cook Islands',
  CR = 'Costa Rica',
  CI = 'CoteDIvoire',
  HR = 'Croatia',
  CU = 'Cuba',
  CY = 'Cyprus',
  CZ = 'CzechRepublic',
  DK = 'Denmark',
  DJ = 'Djibouti',
  DM = 'Dominica',
  DO = 'Dominican Republic',
  EC = 'Ecuador',
  EG = 'Egypt',
  SV = 'El Salvador',
  GQ = 'Equatorial Guinea',
  ER = 'Eritrea',
  EE = 'Estonia',
  ET = 'Ethiopia',
  FK = 'Falkland Islands',
  FO = 'Faroe Islands',
  FJ = 'Fiji',
  FI = 'Finland',
  FR = 'France',
  GF = 'French Guiana',
  PF = 'French Polynesia',
  TF = 'French Southern Territories',
  GA = 'Gabon',
  GM = 'Gambia',
  GE = 'Georgia',
  DE = 'Germany',
  GH = 'Ghana',
  GI = 'Gibraltar',
  GR = 'Greece',
  GL = 'Greenland',
  GD = 'Grenada',
  GP = 'Guadeloupe',
  GU = 'Guam',
  GT = 'Guatemala',
  GG = 'Guernsey',
  GN = 'Guinea',
  GW = 'Guinea Bissau',
  GY = 'Guyana',
  HT = 'Haiti',
  HM = 'Heard Island Mcdonald Islands',
  VA = 'Holy See Vatican City State',
  HN = 'Honduras',
  HK = 'HongKong',
  HU = 'Hungary',
  IS = 'Iceland',
  IN = 'India',
  ID = 'Indonesia',
  IR = 'Iran',
  IQ = 'Iraq',
  IE = 'Ireland',
  IM = 'Isle Of Man',
  IL = 'Israel',
  IT = 'Italy',
  JM = 'Jamaica',
  JP = 'Japan',
  JE = 'Jersey',
  JO = 'Jordan',
  KZ = 'Kazakhstan',
  KE = 'Kenya',
  KI = 'Kiribati',
  KR = 'Korea',
  KW = 'Kuwait',
  KG = 'Kyrgyzstan',
  LA = 'Lao Peoples Democratic Republic',
  LV = 'Latvia',
  LB = 'Lebanon',
  LS = 'Lesotho',
  LR = 'Liberia',
  LY = 'Libyan Arab Jamahiriya',
  LI = 'Liechtenstein',
  LT = 'Lithuania',
  LU = 'Luxembourg',
  MO = 'Macao',
  MK = 'Macedonia',
  MG = 'Madagascar',
  MW = 'Malawi',
  MY = 'Malaysia',
  MV = 'Maldives',
  ML = 'Mali',
  MT = 'Malta',
  MH = 'Marshall Islands',
  MQ = 'Martinique',
  MR = 'Mauritania',
  MU = 'Mauritius',
  YT = 'Mayotte',
  MX = 'Mexico',
  FM = 'Micronesia',
  MD = 'Moldova',
  MC = 'Monaco',
  MN = 'Mongolia',
  ME = 'Montenegro',
  MS = 'Montserrat',
  MA = 'Morocco',
  MZ = 'Mozambique',
  MM = 'Myanmar',
  NA = 'Namibia',
  NR = 'Nauru',
  NP = 'Nepal',
  NL = 'Netherlands',
  AN = 'Netherlands Antilles',
  NC = 'New Caledonia',
  NZ = 'New Zealand',
  NI = 'Nicaragua',
  NE = 'Niger',
  NG = 'Nigeria',
  NU = 'Niue',
  NF = 'Norfolk Island',
  MP = 'Northern Mariana Islands',
  NO = 'Norway',
  OM = 'Oman',
  PK = 'Pakistan',
  PW = 'Palau',
  PS = 'Palestinian Territory',
  PA = 'Panama',
  PG = 'Papua New Guinea',
  PY = 'Paraguay',
  PE = 'Peru',
  PH = 'Philippines',
  PN = 'Pitcairn',
  PL = 'Poland',
  PT = 'Portugal',
  PR = 'Puerto Rico',
  QA = 'Qatar',
  RE = 'Reunion',
  RO = 'Romania',
  RU = 'Russian Federation',
  RW = 'Rwanda',
  BL = 'Saint Barthelemy',
  SH = 'Saint Helena',
  KN = 'Saint Kitts And Nevis',
  LC = 'Saint Lucia',
  MF = 'Saint Martin',
  PM = 'Saint Pierre And Miquelon',
  VC = 'Saint Vincent And Grenadines',
  WS = 'Samoa',
  SM = 'San Marino',
  ST = 'Sao Tome And Principe',
  SA = 'Saudi Arabia',
  SN = 'Senegal',
  RS = 'Serbia',
  SC = 'Seychelles',
  SL = 'Sierra Leone',
  SG = 'Singapore',
  SK = 'Slovakia',
  SI = 'Slovenia',
  SB = 'Solomon Islands',
  SO = 'Somalia',
  ZA = 'South Africa',
  GS = 'South Georgia And Sandwich Island',
  ES = 'Spain',
  LK = 'Sri Lanka',
  SD = 'Sudan',
  SR = 'Suriname',
  SJ = 'Svalbard And Jan Mayen',
  SZ = 'Swaziland',
  SE = 'Sweden',
  CH = 'Switzerland',
  SY = 'Syrian Arab Republic',
  TW = 'Taiwan',
  TJ = 'Tajikistan',
  TZ = 'Tanzania',
  TH = 'Thailand',
  TL = 'TimorLeste',
  TG = 'Togo',
  TK = 'Tokelau',
  TO = 'Tonga',
  TT = 'Trinidad And Tobago',
  TN = 'Tunisia',
  TR = 'Turkey',
  TM = 'Turkmenistan',
  TC = 'Turks And Caicos Islands',
  TV = 'Tuvalu',
  UG = 'Uganda',
  UA = 'Ukraine',
  AE = 'United Arab Emirates',
  GB = 'United Kingdom',
  US = 'United States',
  UM = 'United States Outlying Islands',
  UY = 'Uruguay',
  UZ = 'Uzbekistan',
  VU = 'Vanuatu',
  VE = 'Venezuela',
  VN = 'Vietnam',
  VG = 'Virgin Islands British',
  VI = 'Virgin Islands US',
  WF = 'Wallis And Futuna',
  EH = 'Western Sahara',
  YE = 'Yemen',
  ZM = 'Zambia',
  ZW = 'Zimbabw',
}

export enum CustomCountries {
  AU = 'Australia',
  AT = 'Austria',
  BE = 'Belgium',
  CA = 'Canada',
  CL = 'Chile',
  CZ = 'Czech Republic',
  DK = 'Denmark',
  DE = 'Germany',
  EE = 'Estonia',
  FI = 'Finland',
  FR = 'France',
  GR = 'Greece',
  HU = 'Hungary',
  IE = 'Ireland',
  IS = 'Iceland',
  IL = 'Israel',
  IT = 'Italy',
  JP = 'Japan',
  KR = 'Korea',
  LV = 'Latvia',
  LT = 'Lithuania',
  LU = 'Luxembourg',
  MX = 'Mexico',
  NL = 'Netherlands',
  NZ = 'New Zealand',
  NO = 'Norway',
  PL = 'Poland',
  PT = 'Portugal',
  RO = 'Romania',
  SK = 'Slovakia',
  SI = 'Slovenia',
  ES = 'Spain',
  SE = 'Sweden',
  CH = 'Switzerland',
  TR = 'Turkey',
  GB = 'United Kingdom',
  US = 'United States',
}

export enum LegalCountries {
  AL = 'Albania',
  AD = 'Andorra',
  AG = 'Antigua and Barbuda',
  AR = 'Argentina',
  AM = 'Armenia',
  AU = 'Australia',
  AT = 'Austria',
  AZ = 'Azerbaijan',
  BS = 'Bahamas',
  BH = 'Bahrain',
  BB = 'Barbados',
  BE = 'Belgium',
  BA = 'Bosnia and Herzegovina',
  BR = 'Brazil',
  BN = 'Brunei',
  BG = 'Bulgaria',
  CA = 'Canada',
  CL = 'Chile',
  CN = 'China',
  CY = 'Cyprus',
  CO = 'Colombia',
  CR = 'Costa Rica',
  HR = 'Croatia',
  CZ = 'Czech Republic',
  DK = 'Denmark',
  DO = 'Dominican Republic',
  EC = 'Ecuador',
  EG = 'Egypt',
  EE = 'Estonia',
  FI = 'Finland',
  FR = 'France',
  GE = 'Georgia',
  DE = 'Germany',
  GR = 'Greece',
  HK = 'Hong Kong',
  HU = 'Hungary',
  IS = 'Iceland',
  IN = 'India',
  IE = 'Ireland',
  IL = 'Israel',
  IT = 'Italy',
  JP = 'Japan',
  KZ = 'Kazakhstan',
  KW = 'Kuwait',
  LV = 'Latvia',
  LI = 'Liechtenstein',
  LT = 'Lithuania',
  LU = 'Luxembourg',
  MY = 'Malaysia',
  MT = 'Malta',
  MX = 'Mexico',
  MD = 'Moldova',
  ME = 'Montenegro',
  NL = 'Netherlands',
  NZ = 'New Zealand',
  MK = 'North Macedonia',
  NO = 'Norway',
  OM = 'Oman',
  PA = 'Panama',
  PE = 'Peru',
  PL = 'Poland',
  PT = 'Portugal',
  QA = 'Qatar',
  RO = 'Romania',
  SM = 'San Marino',
  SA = 'Saudi Arabia',
  SC = 'Seychelles',
  RS = 'Serbia',
  SG = 'Singapore',
  SK = 'Slovakia',
  SI = 'Slovenia',
  KR = 'South Korea',
  ES = 'Spain',
  LK = 'Sri Lanka',
  SE = 'Sweden',
  CH = 'Switzerland',
  TR = 'Turkey',
  UA = 'Ukraine',
  AE = 'United Arab Emirates',
  GB = 'United Kingdom',
  US = 'United States',
  UY = 'Uruguay',
}

export enum OECDCountries {
  AU = 'AU',
  AT = 'AT',
  BE = 'BE',
  CA = 'CA',
  CL = 'CL',
  CZ = 'CZ',
  DK = 'DK',
  DE = 'DE',
  EE = 'EE',
  FI = 'FI',
  FR = 'FR',
  GR = 'GR',
  HU = 'HU',
  IE = 'IE',
  IS = 'IS',
  IL = 'IL',
  IT = 'IT',
  JP = 'JP',
  KR = 'KR',
  LV = 'LV',
  LT = 'LT',
  LU = 'LU',
  MX = 'MX',
  NL = 'NL',
  NZ = 'NZ',
  NO = 'NO',
  PL = 'PL',
  PT = 'PT',
  SK = 'SK',
  SI = 'SI',
  ES = 'ES',
  SE = 'SE',
  CH = 'CH',
  TR = 'TR',
  GB = 'GB',
  US = 'US',
}

export enum BusinessCountries {
  AT = 'Austria',
  BE = 'Belgium',
  FR = 'France',
  DE = 'Germany',
  CZ = 'Czech Republic',
  IT = 'Italy',
  EE = 'Estonia',
  LV = 'Latvia',
  LT = 'Lithuania',
  NL = 'Netherlands',
  NO = 'Norway',
  ES = 'Spain',
  PL = 'Poland',
  PT = 'Portugal',
  RO = 'Romania',
}

export enum KycCountries {
  BE = 'Belgium',
  LV = 'Latvia',
  LT = 'Lithuania',
  NL = 'Netherlands',
  PL = 'Poland',
  PT = 'Portugal',
}

export enum CountryCodes {
  LT = 'LT',
  NL = 'NL',
  LV = 'LV',
  BE = 'BE',
  PL = 'PL',
}

export enum KPICountryCodes {
  LT = 'LT',
  NL = 'NL',
  LV = 'LV',
}

export enum EUCountries {
  AT = 'AT', // Austria
  BE = 'BE', // Belgium
  BG = 'BG', // Bulgaria
  HR = 'HR', // Croatia
  CY = 'CY', // Cyprus
  CZ = 'CZ', // Czech Republic
  DK = 'DK', // Denmark
  EE = 'EE', // Estonia
  FI = 'FI', // Finland
  FR = 'FR', // France
  DE = 'DE', // Germany
  GR = 'GR', // Greece
  HU = 'HU', // Hungary
  IE = 'IE', // Ireland
  IT = 'IT', // Italy
  LV = 'LV', // Latvia
  LT = 'LT', // Lithuania
  LU = 'LU', // Luxembourg
  MT = 'MT', // Malta
  NL = 'NL', // Netherlands
  PL = 'PL', // Poland
  PT = 'PT', // Portugal
  RO = 'RO', // Romania
  SK = 'SK', // Slovakia
  SI = 'SI', // Slovenia
  ES = 'ES', // Spain
  SE = 'SE', // Sweden
}
